// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__36ToN","clinicsSelect":"TableHeading_clinicsSelect__x0_t1"};